import { theme } from '@factorialco/deprecated-design-system'
import {
  CompanyHolidayEventFragment,
  LeaveCalendarEventFragment,
} from 'generated/resources/graphql'

import { CalendarEventNormalizer } from 'modules/core/components/CalendarEventList/types'
import { getUIDuration, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import LeaveUtils from 'modules/timeoff/lib/LeaveUtils'
import { getTimeoffDefaultsLabel } from 'modules/timeoff/lib/leaveTypeLabels'

export const leaveCalendarEventNormalizer: CalendarEventNormalizer<LeaveCalendarEventFragment> = (
  item: LeaveCalendarEventFragment
) => {
  const startOn = stringToDate(item.startOn, 'backend_datetime')
  const endOn = item.finishOn ? stringToDate(item.finishOn, 'backend_datetime') : undefined

  const total = LeaveUtils.leaveTotalDaysOrHours(item)
  let description

  if (!endOn) {
    description = i18n.t('dashboard.new_upcoming_absences.no_end_date')
  } else if (total === 0) {
    description = getUIDuration({
      date: endOn.clone().add(1, 'day'),
      fromDate: startOn,
    })
  } else {
    description = LeaveUtils.leaveStringDuration(item)
  }

  const title =
    item.leaveType?.identifier === 'custom'
      ? (item.leaveType.translatedName ?? '')
      : getTimeoffDefaultsLabel(item.leaveType?.identifier ?? 'generic')

  const color = item.leaveType?.color ? `#${item.leaveType.color}` : theme.colors.grey400

  return {
    title,
    color,
    description,
    ...(endOn && !endOn.isSame(startOn, 'day')
      ? {
          fromDate: startOn.toDate(),
          toDate: endOn.toDate(),
        }
      : {
          toDate: startOn.toDate(),
        }),
    isPending: !item.approved,
  }
}

export const companyHolidayNormalizer: CalendarEventNormalizer<CompanyHolidayEventFragment> = (
  item: CompanyHolidayEventFragment
) => {
  const startOn = stringToDate(item.date, 'backend_datetime')

  const description = item.description ?? item.location?.name ?? ''

  const title = item.summary ?? ''

  const color = theme.colors.grey800

  return {
    title,
    color,
    description,
    toDate: startOn.toDate(),
    isPending: false,
  }
}
